import { render, staticRenderFns } from "./DataDive.vue?vue&type=template&id=22eb74ae&scoped=true&"
import script from "./DataDive.vue?vue&type=script&lang=js&"
export * from "./DataDive.vue?vue&type=script&lang=js&"
import style0 from "./DataDive.vue?vue&type=style&index=0&id=22eb74ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eb74ae",
  null
  
)

export default component.exports